import React from "react";
import { Container } from "reactstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          {/* <nav>
            <ul>
              <li>
                <a href="https://www.creative-tim.com">Creative Tim</a>
              </li>
              <li>
                <a href="https://presentation.creative-tim.com">About Us</a>
              </li>
              <li>
                <a href="https://blog.creative-tim.com">Blog</a>
              </li>
            </ul>
          </nav> */}
          <div className="copyright">
            &copy; {1900 + new Date().getYear()} - Designed and coded by{" "}
            <a
              href="https://nadunet.es"
              target="_blank"
              rel="noopener noreferrer"
            >
              nadunet
            </a>
          </div>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx